// extracted by mini-css-extract-plugin
export default {"container":"Txojm","filterText":"boc-h"};